import { ActionList } from 'components/ActionList'
import Box from 'components/Box'
import Heading from 'components/Heading'
import { List, ListItem } from 'components/List'
import Section from 'components/Section'
import { SectionColors, SectionType, Size } from 'components/Section/Section'
import Style from 'components/Style'
import { Timeline, TimelineItem } from 'components/Timeline'
import * as React from 'react'
import { Entry } from '../../../data/entries/types'
import {
  foodLoversDriveOptions,
  foodLoversFlyOptions,
} from '../../../data/models/funnelOrder/days'
import { Theme } from '../../../data/models/funnelOrder/theme'
import { Icon } from '../../../data/models/icon'
import Calendar from '../../../elements/Calendar'
import PersonModal from '../../../elements/modals/PersonModal'
import Airport from '../../funnel/customise/options/airport'
import Days from '../../funnel/customise/options/days'
import FlyExcluded from '../../funnel/customise/options/flyExcluded'
import People from '../../funnel/customise/options/people'
import RoomType from '../../funnel/customise/options/roomType'
import { QueryKey } from '../../funnel/customise/wrapper'
import {
  CustomiseWrapperInnerProps,
  withAirportsAndPrices,
} from '../../funnel/customise/wrapperFunction'
import DisplayContent from '../../shared/content'

interface FoodLoversDetailsProps {
  entry: Entry
}

const FoodLoversDetails: React.FC<FoodLoversDetailsProps &
  CustomiseWrapperInnerProps> = ({ airports, prices, loading, entry }) => {
  return (
    <Section
      type={SectionType.solidTurquoise}
      size={Size.s}
      color={SectionColors.lightTomato}
    >
      <Style margin={[[0, 0, 20, 0]]}>
        <Heading level={5} timelineHeading>
          <DisplayContent contentKey="detail-section-title">
            STEL JE CULINAIRE CITYTRIP SAMEN
          </DisplayContent>
        </Heading>
        <Timeline direction="vertical" numbers>
          <TimelineItem>
            <ActionList>
              <People />
              {entry.page?.params.theme === Theme.foodLoversFly && (
                <FlyExcluded />
              )}
              <Days
                options={
                  entry.page?.params.theme === Theme.foodLoversFly
                    ? foodLoversFlyOptions
                    : foodLoversDriveOptions
                }
              />
              {entry.page?.params.theme === Theme.foodLoversFly && (
                <Airport {...{ airports }} />
              )}
              <RoomType />
              <Style margin={[[40, 0, 0, 0]]}>
                <List isText>
                  <ListItem>
                    <DisplayContent contentKey={`timeline-list-item-1`}>
                      timeline item
                    </DisplayContent>
                  </ListItem>
                  <ListItem>
                    <DisplayContent contentKey={`timeline-list-item-2`}>
                      timeline item
                    </DisplayContent>
                  </ListItem>
                  <ListItem>
                    <DisplayContent contentKey={`timeline-list-item-3`}>
                      timeline item
                    </DisplayContent>
                  </ListItem>
                </List>
              </Style>
            </ActionList>
          </TimelineItem>
          <TimelineItem>
            <Box fullWidthMobile>
              <Calendar
                icon={Icon.calendar}
                actionList
                hideTrigger
                showCheapest={false}
                prices={prices}
                loading={loading}
              />
            </Box>
          </TimelineItem>
        </Timeline>
      </Style>
      <PersonModal />
    </Section>
  )
}

export default withAirportsAndPrices<FoodLoversDetailsProps>(
  FoodLoversDetails,
  [QueryKey.month, QueryKey.year],
)
